<template>
  <div class="header">
    <div class="nav-list">
      <div class="logo-list">
        <router-link class="logo1" to="/">
          <img src="../assets/logo_1.png" alt="">
        </router-link>
        <router-link class="logo2" to="/">
          <img src="../assets/logo_2.png" alt="">
        </router-link>
      </div>
      <div class="link-list--pc">
        <router-link class="item" to="/">主页</router-link>
        <router-link class="item" to="/projects">项目介绍</router-link>
        <router-link class="item" to="/prereview">往期精彩回顾</router-link>
        <router-link class="item" to="/aboutbytedance">关于字节跳动</router-link>
      </div>
      <div class="link-list--mobile" :class="{'link-list--active':navStatus, 'mobile-list': isMobileStatus}">
        <router-link class="item" @click.native="navChange" to="/">主页</router-link>
        <router-link class="item" @click.native="navChange" to="/projects">项目介绍</router-link>
        <router-link class="item" @click.native="navChange" to="/prereview">往期精彩回顾</router-link>
        <router-link class="item" @click.native="navChange" to="/aboutbytedance">关于字节跳动</router-link>
      </div>
      <div class="nav-icon" @click="navChange"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      isMobileStatus: false,
      navStatus: false
    }
  },
  mounted: function() {
    // this.$refs.videoRef.src = "http://iandevlin.github.io/mdn/video-player/video/tears-of-steel-battle-clip-medium.mp4";
    // this.$refs.videoRef.play();
  },
  methods: {
    _isMobile(){
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    navChange() {
      console.log(123)
      this.navStatus = !this.navStatus
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  position: fixed;
  width: 100%;
  padding: 0 1em;
  box-sizing: border-box;
  background-color: #fff;
  z-index: 1;
  .nav-list, .logo-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    a {
      color: #000A2A;
    }
    .logo1 img, .logo2 img {
      width: 100%;
    }
  }
  .nav-list .router-link-exact-active, .item:hover {
    font-weight: 400;
    color: #458FFF;
  }
  @media screen and (min-width: 576px) {
    height: 4em;
    .nav-list {
      width: 70%;
      min-width: 850px;
      max-width: 1000px;
      height: 100%;
      margin: 0 auto;
      font-size: 18px;
      font-weight: 300;
      .link-list--mobile {
        display: none;
      }
      .link-list--pc {
        width: 70%;
        margin-left: 3em;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .item {
          flex-grow: 1;
          border-right: 1px solid #E9E9E9;
          &:last-child {
            border-right: 0;
          }
        }
      }
      .logo1 {
        width: 150px;
        padding-right: 2em;
      }
      .logo2 {
        width: 90px;
        align-self: flex-end;
      }
    }
  }
  @media screen and (max-width: 575px) {
    height: 4em;
    .nav-list {
      height: 100%;
      font-size: 1em;
      text-align: center;
      .link-list--pc {
        display: none;
      }
      .link-list {
        &--mobile {
          display: none;
          position: absolute;
          right: 0;
          top: 4em;
          background-color: #fff;
          border-top: 0.5px solid #4590FF;
          &::before, &::after {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            right: 1.7em;
            border: 6px solid transparent;
          }
          &::before {
            top: -12px;
            border-bottom-color: #4590FF;
          }
          &::after {
            top: -11px;
            border-bottom-color: #fff;
          }
          .item {
            display: block;
            padding: 0 1em;
            line-height: 2.5em;
            border-bottom: 0.5px solid #4590FF;
          }
        }
        &--active {
          display: block;
        }
      }
      .logo1 {
        width: 110px;
        padding-left: .5em;
        padding-right: 1.5em;
      }
      .logo2 {
        width: 70px;
        align-self: flex-end;
      }
      .nav-icon {
        width: 2em;
        height: 2em;
        background: url("../assets/nav-icon.svg") no-repeat center;
      }
    }
  }
}
</style>